import { useState } from 'react';

import { ErrorModal } from '../../../../modals';
import { Modal, Typography, Textarea, Button, Icon } from '@virkesborsen/ui-component-library';

import { feedbackSubmission } from '../../../../api/services/dfr';

const ratingOptions = [
    {label: 'Mindre nöjd', value: 'bad', icon: 'SmileySadSimple'},
    {label: 'Helt okej', value: 'neutral', icon: 'SmileyMehSimple'},
    {label: 'Väldigt nöjd', value: 'good', icon: 'SmileySimple'}
]

export default function FeedbackModal({show, setShow}) {
    const [rating, setRating] = useState(null);
    const [tags, setTags] = useState([]);
    const [comment, setComment] = useState('');

    const [error, setError] = useState({});
    const [errorModal, setErrorModal] = useState(false);

    const [success, setSuccess] = useState(false);

    const smileyButton = item => {
        const classes = rating == item.value ? 'bg-charcoal-500 border-charcoal-500 white' : 'charcoal-500 border-pebble-50 bg-white'
        const iconColor = rating == item.value ? 'spring-yellow-500' : 'charcoal-500'
        return <div className='col px-1'>
            <div role='button' className={`text-center border border-1 ${classes}`} style={{borderRadius: '12px', padding: '12px 0'}} onClick={() => setRating(item.value)}>
                <Icon name={item.icon} color={iconColor} size='xlarge' />
                <Typography className='text-nowrap user-select-none' style={{marginTop: '16px'}} variant='labelLargeMedium'>{item.label}</Typography>
            </div>
        </div>
    }

    const tagItem = item => {
        const exists = tags.find(tag => tag.value == item.value)
        const classes = exists ? 'bg-charcoal-500 border-charcoal-500 white' : 'charcoal-500 border-pebble-50 bg-white'
        return <div role='button' className={`rounded rounded-4 border border-1 px-2 py-1 ${classes}`} onClick={() => setTags(exists ? tags.filter(t => t.value != item.value) : [...tags, item])}>
            <Typography className='text-nowrap user-select-none' variant='labelMediumMedium'>{item.label}</Typography>
        </div>
    }

    const handleSubmit = async () => {
        if(rating) {
            const data = { rating: rating, tags: tags.map(tag => tag.value).join(';'), comment: comment }

            const resp = await feedbackSubmission(data)
            console.log('resp', resp)
            if(resp.ok) {
                setSuccess(true)
            } else {
                setErrorModal(true)
            }
        } else {
            setError({rating: 'Vänligen välj ett alternativ för att gå vidare.'})
        }
    }

    const closeModal = () => {
        setSuccess(false)
        setShow(false)
        setRating(null)
        setTags([])
        setComment('')
    }

    const formContent = () => {
        return <Modal.Content>
            <div className='d-flex flex-column justify-content-around gap-3'>
                <div>
                    <Typography style={{marginBottom: '16px'}} variant='introLeadSmallRegular'>Vad är din upplevelse av tjänsten? *</Typography>

                    <div className='d-flex'>
                        {ratingOptions.map(option => smileyButton(option))}
                    </div>

                    {error.rating && <Typography color='danger-500' variant='captionRegular'>{error.rating}</Typography>}
                </div>
                
                {Window.react_data.dfr_feedback_tags && <div>
                    <Typography style={{marginBottom: '16px'}} variant='introLeadSmallRegular'>Välj en eller flera som passar in</Typography>
                    <div className='d-flex flex-wrap align-items-center gap-1'>
                        {Window.react_data.dfr_feedback_tags.map(option => tagItem(option))}
                    </div>
                </div>}
                
                <div>
                    <Typography style={{marginBottom: '16px'}} variant='introLeadSmallRegular'>Vill du lägga till något mer? (frivilligt)</Typography>
                    <Textarea value={comment} onChange={(value) => setComment(value)} minRows={5} placeholder='Exempelvis: vad som var bra, saknades eller kändes otydligt.' />
                </div>
            </div>
        </Modal.Content>
    }

    const successContent = () => { 
        return <div className='d-flex flex-column align-items-center justify-content-center h-100 p-3'>
            <div className='d-flex align-items-center justify-content-center rounded rounded-circle bg-stone-100 mb-3' style={{width: '60px', height: '60px'}}>
                <Icon name='CheckSimple' color='charcoal-500' size='xlarge' />
            </div>
            <Typography variant='subheaderMediumMedium' style={{marginBottom: '12px'}}>Tack för din feedback!</Typography>
            <Typography variant='introLeadMediumRegular'>Det hjälper oss att förbättra tjänsten.</Typography>
        </div>
    }

    return <>
        <Modal isOpen={show} borderLess onClose={closeModal}>
            <Modal.Header>
                <Typography className='w-100 text-center' variant='labelMediumMedium'>{!success ? 'Hjälp oss att förbättra skogsövervakning' : ''}</Typography>

                <div role='button' onClick={closeModal}>
                    <Icon name='CrossSimple' size='large' color='charcoal-500' />
                </div>
            </Modal.Header>

            {!success && formContent()}
            {success && successContent()}

            <Modal.Footer>
                {!success && <Button label='Skicka feedback' className='w-100' onClick={handleSubmit} />}
                {success && <Button label='Tillbaka till skogsövervakning' className='w-100' onClick={closeModal} />}
            </Modal.Footer>
        </Modal>

        <ErrorModal show={errorModal} onToggle={() => setErrorModal(false)} />
    </>
};
